import {
  toWSDateString,
  WSTableCell,
  WSTableColumn,
  WSTableColumnSortDirection
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { TableItemData } from "./TableTransactions";

type ColumnsConfig = {
  accountNameById: Map<string, string>;
  onSortByDate: (direction: WSTableColumnSortDirection) => void;
  dateDirection?: WSTableColumnSortDirection;
};

export const getColumns = ({
  accountNameById,
  onSortByDate,
  dateDirection
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      header: { text: "Transaction" },
      gridTemplateSizeMax: "1.5fr"
    },
    renderFunction: ({ data }) => (
      <WSTableCell
        avatar={{ type: "text", text: data.merchantName || data.name }}
        text={data.merchantName || data.name}
        icon={data.receiptFileId ? "paperclip" : undefined}
        truncationOptions={{ text: { allowTwoLines: true } }}
      />
    )
  },
  {
    config: {
      header: { text: "Category" },
      gridTemplateSizeMax: "1fr",
      hideOnScreens: ["XS"]
    },
    renderFunction: ({ data }) => {
      const secondaryText = [
        data.subcategory,
        data.isBusiness ? undefined : "Personal"
      ]
        .filter(Boolean)
        .join(" · ");
      return (
        <WSTableCell
          text={data.wsCategory || "Uncategorized"}
          secondaryText={secondaryText || undefined}
          secondaryTextColor={data.isBusiness ? undefined : "gray400"}
        />
      );
    }
  },
  {
    config: {
      header: { text: "Account" },
      gridTemplateSizeMax: "1fr",
      hideOnScreens: ["XS"]
    },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={
          data.externalBankAccountId
            ? accountNameById.get(data.externalBankAccountId) || "Bank account"
            : "Manually added"
        }
      />
    )
  },
  {
    config: {
      header: { text: "Date" },
      gridTemplateSizeMax: "0.75fr",
      onColumnSort: onSortByDate,
      sortDirection: dateDirection
    },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={data.date ? toWSDateString(data.date, "monthDayYear") : "—"}
      />
    )
  },
  {
    config: {
      header: { text: "Amount" },
      gridTemplateSizeMax: "0.75fr",
      justify: "end"
    },
    renderFunction: ({ data }) => (
      <WSTableCell text={formatMoney(Number(data.amount), data.currency)} />
    )
  }
];
